export const PAYMENT_STATUSES: {
  [K in paymentStatus]: paymentStatus;
} = {
  Ready: 'Ready',
  Pending: 'Pending',
  Failed: 'Failed',
  Aborted: 'Aborted',
  Reversed: 'Reversed',
};

export const DISTANCE_MODES: {
  [K in string]: distanceModes;
} = {
  classic: 1,
  virtual: 2,
  cumulative: 3,
};

export const GOAL_TYPE: {
  [K in string]: goalType;
} = {
  DISTANCE: 1,
  ALTITUDE: 2,
};
